import AvatarPage from "../../../../avatar-page";

const Delay = (props) => {
   return (
      <div className="row-wrapper">
         <div className="hide-avatar">
            <AvatarPage />
         </div>
         <div className="row-wrapper__children">
            <div className="card-delay">
               <span>
               </span>
               <span>
               </span>
               <span>
               </span>
            </div>
         </div>
      </div>
   )
}

export default Delay;